/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */

import React from "react";
import { Select, SelectItem, SelectProps } from "@heroui/select";

interface FilterSelectProps extends Omit<SelectProps, "children"> {
  label: string;
  options: any[];
}

const FilterSelect: React.FC<FilterSelectProps> = ({
  label,
  options,
  ...props
}) => {
  return (
    <Select
      {...props}
      disallowEmptySelection
      isRequired
      classNames={{
        trigger:
          "px-4 md:px-6 border-[#B5B5B5] border-1 data-[disabled=true]:bg-[#F5F5F5]",
        selectorIcon: "end-6",
      }}
      label={label}
      selectorIcon={
        <svg
          fill="none"
          height="10"
          viewBox="0 0 22 10"
          width="22"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.2002 1.16602L11 9.3584L0.798828 1.16602L1.45215 0.640625L10.6865 8.05664L11 8.30762L11.3135 8.05664L20.5469 0.640625L21.2002 1.16602Z"
            fill="black"
            stroke="#CC3333"
          />
        </svg>
      }
      unselectable="off"
      variant="bordered"
    >
      {options.map((option) => (
        <SelectItem key={String(option)}>{String(option)}</SelectItem>
      ))}
    </Select>
  );
};

export default FilterSelect;
